module.exports = __webpack_public_path__ + "img/school_logo.bcec3817.png";